'use client';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import { ReactLenis } from '@studio-freight/react-lenis';
import { ComponentProps, forwardRef } from 'react';

interface Props extends ComponentProps<typeof ReactLenis> {}

export const SmoothScroll = forwardRef<any, Props>(({ children, className, ...props }, ref) => {
  return (
    <ReactLenis ref={ref} className={twMergeExt('lenis-container', className)} {...props}>
      {children}
    </ReactLenis>
  );
});

SmoothScroll.displayName = 'SmoothScroll';
